export default {
  en: {    
    EXPORTED_FILES_DETAILS: 'Exported Files',
    ERROR_PLEASE_TRY_AGAIN: 'Error: please try again',
    DOWNLOAD_REPORT: 'Download report'
  }
};